export default __webpack_public_path__ + "static/bed-bath-beyond-3-cc-2be0d8eabd7f9eb8869f8a1d71294ac6.webp";